import { useState, useEffect, useContext } from "react";
import { message } from "antd";
import { FirebaseContext } from "../../../../context/firebaseContext";
import { DocumentData } from "firebase/firestore";

export default function useScenarios(subscriptionId: string) {
  const [scenarios, setScenarios] = useState<DocumentData[]>([]);
  const { getScenariosBySubscriptionId } = useContext(FirebaseContext);

  useEffect(() => {
    const loadScenarios = async () => {
      try {
        if (subscriptionId) {
          const result = await getScenariosBySubscriptionId(subscriptionId);
          if (result.success) {
            setScenarios(result.doc || []);
          } else {
            message.error(result.msg);
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des scenarios :", error);
        message.error("Une erreur est survenue lors du chargement des scenarios.");
      }
    };

    loadScenarios();
  }, [subscriptionId, getScenariosBySubscriptionId]);

  return scenarios;
}
